import type { Verification } from '../../graphql/hirer-types.generated';

export const hasVerificationsData = ({
  verifiedIdentity,
  workHistory,
  education,
  licences,
  rightToWork,
}: {
  verifiedIdentity?: Verification;
  workHistory: Verification[];
  education: Verification[];
  licences: Verification[];
  rightToWork: Verification[];
}): boolean => {
  if (verifiedIdentity) {
    return true;
  }

  if (
    [workHistory, education, licences, rightToWork].find(
      (array) => array && array.length > 0,
    )
  ) {
    return true;
  }

  return false;
};
